// extracted by mini-css-extract-plugin
export var active = "_21-d";
export var blink = "_21-e";
export var container = "_21-5";
export var controls = "_21-0";
export var controlsRight = "_21-1";
export var fakeCursor = "_21-c";
export var hidden = "_21-b";
export var quillContainerSmall = "_21-7";
export var quillEditor = "_21-6";
export var quillEditorSmall = "_21-8";
export var quillFormatButtons = "_21-a";
export var quillToolbar = "_21-9";
export var removePadding = "_21-2";
export var state = "_21-3";
export var stateTitle = "_21-4";